import { createContext, useContext } from 'react';

/**
 * How a surface opens the conversation belonging to an open letter.
 *
 * A conversation keeps its public `/letters/:id` address, but a letter opened
 * from a list is presented over that list. The route owning the list supplies
 * the masked, nested destination; `PostCard` only needs to know that a nearby
 * surface can keep its place underneath the conversation.
 *
 * `null` is meaningful: direct links, notifications and any future standalone
 * surface keep using the ordinary full-page letter route.
 */
type OpenThreadSheet = (id: string) => void;

const ThreadSheetContext = createContext<OpenThreadSheet | null>(null);

export function ThreadSheetProvider({
  children,
  open,
}: {
  children: React.ReactNode;
  open: OpenThreadSheet;
}) {
  return (
    <ThreadSheetContext.Provider value={open}>
      {children}
    </ThreadSheetContext.Provider>
  );
}

export function useThreadSheet(): OpenThreadSheet | null {
  return useContext(ThreadSheetContext);
}
